module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "CHAP-TITLE1"
  }, [_vm._v("Basic Stitches")]), _vm._v(" "), _c('p', {
    staticClass: "INTRO3"
  }, [_vm._v("There are only a few basic crochet stitches and they’re easy to master. To achieve work with an even finish, do not pull the yarn too tightly, so you can draw the hook through the loops easily and always maintain the same tension. All patterns in this book use abbreviations for the stitch names and other key crochet terms – a list of abbreviations and their meanings are in the Conversion Charts section. Please note that UK crochet terms are used throughout. The Conversion Charts section lists the UK terms with their US equivalent.")]), _vm._v(" "), _c('h2', {
    staticClass: "SbS-AHD"
  }, [_vm._v("CHAIN (ABBREVIATION – CH)")]), _vm._v(" "), _c('p', {
    staticClass: "SbS1-1"
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v("1.")]), _vm._v(" Make a slipknot by wrapping the yarn around the hook, then drawing it through the loop.")]), _vm._v(" "), _c('p', {
    staticClass: "IMAGE"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C2-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "SbS1-1"
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v("2.")]), _vm._v(" To form a chain, take the yarn over the hook (take the yarn from the back over the hook to the front) and draw through the loop.")]), _vm._v(" "), _c('p', {
    staticClass: "IMAGE"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C2-2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "SbS1-1"
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v("3.")]), _vm._v(" Repeat stage 2 until you have the required number of stitches. The loop on the hook is not counted as a stitch. The drawing below shows a chain made up of 4 chain stitches.")]), _vm._v(" "), _c('p', {
    staticClass: "IMAGE"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C2-3.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "SbS-AHD"
  }, [_vm._v("SLIP STITCH (ABBREVIATION – SS)")]), _vm._v(" "), _c('p', {
    staticClass: "SbS1-1"
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v("1.")]), _vm._v(" Make a foundation chain. Insert the hook into the stitch indicated in the instructions.")]), _vm._v(" "), _c('p', {
    staticClass: "IMAGE"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C2-4.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "SbS1-1"
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v("2.")]), _vm._v(" Yarn over hook and draw the yarn through both loops. One loop remains on the hook.")]), _vm._v(" "), _c('p', {
    staticClass: "IMAGE"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C2-5.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "SbS-AHD"
  }, [_vm._v("DOUBLE CROCHET (ABBREVIATION – DC)")]), _vm._v(" "), _c('p', {
    staticClass: "SbS1-1"
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v("1.")]), _vm._v(" Make a foundation chain. Insert the hook into the 2nd stitch from the hook (or into the stitch indicated in the instructions).")]), _vm._v(" "), _c('p', {
    staticClass: "IMAGE"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C2-6.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "SbS1-1"
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v("2.")]), _vm._v(" Yarn over hook and draw the yarn through one loop. Two loops remain on the hook.")]), _vm._v(" "), _c('p', {
    staticClass: "IMAGE"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C2-7.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "SbS1-1"
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v("3.")]), _vm._v(" Yarn over hook and draw the yarn through both loops. One loop remains on the hook.")]), _vm._v(" "), _c('p', {
    staticClass: "IMAGE"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C2-8.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "SbS-AHD"
  }, [_vm._v("HALF TREBLE (ABBREVIATION – HTR)")]), _vm._v(" "), _c('p', {
    staticClass: "SbS1-1"
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v("1.")]), _vm._v(" Make a foundation chain. Yarn over and insert the hook into the 3rd stitch from the hook (or into the stitch indicated in the instructions).")]), _vm._v(" "), _c('p', {
    staticClass: "IMAGE"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C2-9.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "SbS1-1"
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v("2.")]), _vm._v(" Yarn over hook and draw the yarn through one loop. Three loops remain on the hook.")]), _vm._v(" "), _c('p', {
    staticClass: "IMAGE"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C2-10.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "SbS1-1"
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v("3.")]), _vm._v(" Yarn over hook. Draw the yarn through three loops. One loop remains on the hook.")]), _vm._v(" "), _c('p', {
    staticClass: "IMAGE"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C2-11.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "SbS-AHD"
  }, [_vm._v("TREBLE (ABBREVIATION – TR)")]), _vm._v(" "), _c('p', {
    staticClass: "SbS1-1"
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v("1.")]), _vm._v(" Make a foundation chain. Yarn over and insert the hook into the 4th stitch from the hook (or into the stitch indicated in the instructions).")]), _vm._v(" "), _c('p', {
    staticClass: "IMAGE"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C2-12.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "SbS1-1"
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v("2.")]), _vm._v(" Yarn over hook and draw the yarn through one loop. Three loops remain on the hook.")]), _vm._v(" "), _c('p', {
    staticClass: "IMAGE"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C2-13.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "SbS1-1"
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v("3.")]), _vm._v(" Yarn over hook and draw the yarn through the two loops. Two loops remain on the hook.")]), _vm._v(" "), _c('p', {
    staticClass: "IMAGE"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C2-14.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "SbS1-1"
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v("4.")]), _vm._v(" Yarn over hook and draw the yarn through both loops. One loop remains on the hook.")]), _vm._v(" "), _c('p', {
    staticClass: "IMAGE"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C2-15.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "SbS-AHD"
  }, [_vm._v("DOUBLE TREBLE (ABBREVIATION – DTR)")]), _vm._v(" "), _c('p', {
    staticClass: "SbS1-1"
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v("1.")]), _vm._v(" Make a foundation chain. Bring yarn over the hook twice and insert the hook into the 5th stitch from the hook (or into the stitch indicated within the instructions).")]), _vm._v(" "), _c('p', {
    staticClass: "IMAGE"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C2-16.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "SbS1-1"
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v("2.")]), _vm._v(" Yarn over hook and draw the yarn through one loop. Four loops remain on the hook.")]), _vm._v(" "), _c('p', {
    staticClass: "IMAGE"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C2-17.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "SbS1-1"
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v("3.")]), _vm._v(" Yarn over hook and draw the yarn through two loops. Three loops remain on the hook.")]), _vm._v(" "), _c('p', {
    staticClass: "IMAGE"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C2-18.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "SbS1-1"
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v("4.")]), _vm._v(" Yarn over hook and draw the yarn through two loops. Two loops remain on the hook.")]), _vm._v(" "), _c('p', {
    staticClass: "IMAGE"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C2-19.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "SbS1-1"
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v("5.")]), _vm._v(" Yarn over hook and draw the yarn through two loops. One loop remains on the hook.")]), _vm._v(" "), _c('p', {
    staticClass: "IMAGE"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C2-20.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-019e9ba1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter2-2.vue
// module id = 111
// module chunks = 0